import shallowEqual from 'fbjs/lib/shallowEqual';

export default (prevProps, nextProps) => (shallowEqual(prevProps, nextProps));
